<template>
  <div>
    <div class="d-flex flex-column h-100">
      <div>
        <SystemBar ref="system-bar" />
      </div>
      <div class="flex-fill overflow-auto px-5 py-3">
        <div class="py-5 my-5" style="width: 100% !important" v-if="$store.state.questionnary.loading">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
        <div v-else style="width: 100% !important">
          <h3
            class="font-weight-regular mb-5"
          >
            {{ $organization.questionViewTitle() }}
          </h3>
          <h4 class="my-4 font-weight-regular text--secondary">
            {{ $organization.questionViewDescription() }}
          </h4>
          <form
            v-if="$store.state.questionnary.item"
            v-on:submit.prevent="submitHandler"
          >
            <div
              class="form-group"
              v-for="(question, index) in $store.state.questionnary.item.questions"
              :key="`question-${index}`"
            >
              <v-row class="ma-0 pa-0">
                <v-col v-if="question.question_type_id === 7" class="ma-0 pa-0" cols="4">
                  <article v-if="inputLabel($t('code'))" class="form-control-label">
                    {{ inputLabel($t('code')) }}
                  </article>
                  <v-select
                    :label="$t('code').length <= 25 ? $t('code') : null"
                    v-model="countries.code"
                    :items="countries.list"
                    item-text="nameCode"
                    item-value="dial_code"
                    outlined
                    hide-details
                    dense
                    required
                    class="mb-3 me-1 os-rounded"
                  ></v-select>
                </v-col>
                <v-col class="ma-0 pa-0" :cols="question.question_type_id === 7 ? 8 : 12">
                  <article v-if="inputLabel(question.question)" class="form-control-label">
                    {{ inputLabel(question.question) }}
                  </article>
                  <v-combobox
                    :label="question.question.length <= 25 ? question.question : null"
                    v-if="question.question_type_id === 1"
                    :placeholder="question.description"
                    v-model="form[question.reference]"
                    :items="question.answers"
                    item-text="answer"
                    outlined
                    hide-details
                    dense
                    multiple
                    :on-icon="'$checked'"
                    :off-icon="'$uncheck'"
                    class="mb-3 os-rounded"
                  >
                    <template v-slot:item="{ item, on, attrs }">
                      <v-list-item v-on="on" v-bind="attrs">
                        <span
                          >
                          <Icon
                            :width="24"
                            :color="'currentColor'"
                            :icon="form[question.reference] && form[question.reference].includes(item) ? 'checked' : 'unchecked'"
                          />
                        </span
                        >
                        <span class="ml-2"> {{ item.answer }}</span>
                      </v-list-item>
                    </template>
                  </v-combobox>
                  <v-textarea
                    v-else-if="question.question_type_id === 6"
                    :label="question.question.length <= 25 ? question.question : null"
                    :placeholder="question.description"
                    :required="question.is_required"
                    v-model="form[question.reference]"
                    persistent-placeholder
                    outlined
                    hide-details
                    dense
                    class="mb-3 os-rounded"
                  ></v-textarea>
                  <v-select
                    :label="question.question.length <= 25 ? question.question : null"
                    v-else-if="question.question_type_id === 2"
                    :placeholder="question.description"
                    v-model="form[question.reference]"
                    :items="question.answers"
                    item-text="answer"
                    outlined
                    hide-details
                    :required="question.is_required"
                    class="mb-3 os-rounded"
                    dense
                  ></v-select>
                  <v-text-field
                    v-else
                    persistent-placeholder
                    :label="question.question.length <= 25 ? question.question : null"
                    :placeholder="question.description"
                    :required="question.is_required"
                    :type="setInputType(question.question_type_id)"
                    v-model="form[question.reference]"
                    outlined
                    @keyup="validateIdentification(question.question_type_id, question.reference)"
                    :error-messages="errorMessaje(question.question_type_id, question.question)"
                    @blur="rutValidate(form[question.reference], question.question_type_id)"
                    :disabled="button.submit.loading"
                    hide-details
                    dense
                    class="mb-3 os-rounded"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>

            <v-row class="mt-4 justify-center">
              <v-col v-if="$organization.doNotAnswerQuestion()" cols="6" :class="{'d-none':this.$store.state.widget.embedMode}">
                <v-btn
                  class="font-weight-bold os-rounded"
                  @click="answer(false)"
                  type="button"
                  block
                  depressed
                  color="white"
                  v-if="$organization.doNotAnswerQuestion()"
                >
                  {{$t('question.doNotAnswer')}}
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  class="font-weight-bold os-rounded"
                  @click="answer(true)"
                  block
                  elevation="0"
                  color="primary"
                  :loading="button.submit.loading"
                  data-action="Botón continuar del formulario inicial"
                  data-position="0"
                  data-analityc-actuator="saveAnalitycHistory"
                  :disabled="button.submit.loading"
                >
                  {{$t('question.continue')}}
                </v-btn>
              </v-col>
            </v-row>
          </form>
        </div>
      </div>
      <div>
        <OcularSign />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import MainService from '@/services/MainService'

import countries from '@/resources/json/countries.json'

require('@/services/Questionnary')
require('@/plugins/RutValidator')
require('@/plugins/dynamics365/indumotora/Cotization')

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue'),
    SystemBar: () => import(/* webpackPrefetch: true */ '@/components/SystemBar.vue'),
    OcularSign: () => import(/* webpackPrefetch: true */ '@/components/OcularSign.vue'),
  },
  watch: {
    '$store.state.storage.room.customer': function (customer) {
      this.toggleSubmitButton()
      this.initFormState()
      this.toggleSubmitButton()
    },
    '$store.state.questionnary.item': function (questionnary) {
      if (questionnary) {
        this.initMainQuestionny()
      }
    }
  }
})
export default class Question extends Vue {
  data () {
    return {
      button: {
        submit: {
          loading: false,
          disabled: false
        }
      },
      questionnary: {
        loading: false,
        item: null,
        answered: false
      },
      countries: {
        list: countries,
        code: countries[0].dial_code
      },
      form: {},
      rutError: false
    }
  }

  mounted () {
    this.getMainQuestionny()
    this.listCountryCodeAndName()
  }

  inputLabel (label) {
    return label.length > 25 ? label : null
  }

  listCountryCodeAndName () {
    for (let index = 0; index < this.countries.list.length; index++) {
      const country = this.countries.list[index]
      country.nameCode =  `${country.dial_code} - ${country.name}`
    }
    // country sort for name
    this.countries.list.sort((a, b) => {
      return  (a.name > b.name) ? 1 : (a.name < b.name) ? -1 : 0
    })
  }

  getMainQuestionny () {
    this.$questionnary.getMainQuestionnary(2)
  }

  initMainQuestionny () {
    if (Vue.prototype.$cityMap.country.iso) {
      const country =  this.countries.list.find((item) => item.code === Vue.prototype.$cityMap.country.iso)

      if (country) {
        this.countries.code = country.dial_code
      }
    }
  }

  validateIdentification (typeId, reference) {
    let value = this.form[reference]
    let length = value.length

    if (typeId === 9 && value && length > 2) {
      if (value.split('-')) {
        value = value.split('-').join('')
        length = value.length
      }
      let lastCharacter = value.slice(-1)

      if (lastCharacter === 'k') {
        lastCharacter = 'K'
      }
      const newValue =  `${value.slice(0, (length - 1))}-${lastCharacter}`
      this.form[reference] = newValue
      this.rutError = false
      this.$forceUpdate()
    }
  }

  errorMessaje(typeId, question) {
    if (typeId == 9 && this.rutError) return `El ${question} no es válido`
  }

  rutValidate(value, typeId) {
    if(typeId == 9) {
      this.rutError = !this.$rutValidator.formatValidator(value)
    }
  }

  setInputType (typeId) {
    let type = ''

    switch (typeId) {
      case 3:
        type = 'text'
        break
      case 4:
      case 7:
        type = 'number'
        break
      case 5:
        type = 'email'
        break
      default:
        type = ''
        break
    }

    return type
  }

  toggleSubmitButton () {
    this.button.submit.loading = !this.button.submit.loading
    this.button.submit.disabled = !this.button.submit.disabled
  }

  getSessionAnswers () {
    const answers = Object.keys(this.form)
    const sessionAnswers = []

    for (let index = 0; index < answers.length; index++) {
      const question = this.$store.state.questionnary.item.questions[index]
      const answer = answers[index]

      sessionAnswers.push(
        {
          questionId: question.id,
          questionTypeId: question.question_type_id,
          answerId: question.answers[0].id,
          reference: question.reference,
          answer: `${question.question_type_id === 7 ? this.countries.code : '' }${question.question_type_id === 1 ? this.form[answer].map( (i) => i.answer).join('|')  : this.form[answer]}`
        }
      )
    }
    return sessionAnswers
  }

  saveAnalitycsEvent (type, detail) {
    const questionFilled = {
      action: 'El cliente continuo luego de responder la encuesta',
      detail,
      actionType: 'STAH',
      functionality: 14,
      historyInteractionType: 'QSGOOD'
    }

    const questionNotAnswered = {
      action: 'Botón de No Responder',
      detail,
      actionType: 'STAH',
      functionality: 14,
      historyInteractionType: 'QSBAD'
    }

    const objectData = type === 0 ? questionFilled : questionNotAnswered

    this.$ocularAnalitycs.widgetAnalitycsEvent(objectData)
  }

  answer (status) {
    let sessionAnswers = []

    this.questionnary.answered = status

    if (this.questionnary.answered) {
      sessionAnswers = this.getSessionAnswers()
    }

    this.submitHandler(sessionAnswers)
  }

  submitHandler (sessionAnswers) {
    if (this.rutError) {
      this.saveAnalitycsEvent('El cliente ingreso un RUT incorrecto')
      return false
    }

    const sessionId = this.$store.state.storage.room.session.id
    const questionnaryId = this.$store.state.questionnary.item.id

    const data = {
      route: 'ocular/widget/session-answers',
      params: {
        sessionAnswers,
        questionnaryCode: this.$store.state.storage.form.code,
        questionnaryId,
        sessionId
      }
    }

    this.toggleSubmitButton()

    MainService.post(data)
      .then((response) => {
        const res = response.data

        if (res.statusCode === 0) {
          if (this.questionnary.answered) {
            this.saveAnalitycsEvent(0, 'El cliente llenó el formulario de encuentas')
          } else {
            this.saveAnalitycsEvent(1, 'el cliente No completo la encuesta y continua')
          }
          this.$storage.setState(5)
          this.$router.replace({ path: '/calification' })
        } else if (res.statusCode === 11) {
          this.$store.commit('notify', {
            color: 'warning',
            message: this.$t('maintenance.text')
          })
        }
      })
      .catch((e) => {
        console.log(e)
        this.toggleSubmitButton()
      })
      .then(() => {
        this.toggleSubmitButton()
      })
  }
}
</script>
